exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".autocomplete-suggestion.is-active[data-v-475638ce],.autocomplete-suggestion[data-v-475638ce]:hover{background-color:#01564b;color:#fff}.autocomplete[data-v-475638ce]{padding-left:2px;background-color:#fff;border-radius:5px}", ""]);

// exports
